<template>
  <div class="apply">
    <div class="header"></div>
    <van-form
      @submit="onSubmit"
      :show-error="false"
      class="apply-content"
      :show-error-message="false"
    >
      <div class="title">
        <div class="main-title">
          <span class="line">-</span> 请填写报名信息 <span class="line">-</span>
        </div>
        <div class="sub-title">请准确填写信息你所在城市及年级，匹配作文命题范围</div>
      </div>
      <van-field
        v-model="form.name"
        name="姓名"
        label="姓名"
        placeholder="请输入你的姓名"
        @input="inputName"
        :error-message="errMsg.name"
      ></van-field>
      <van-field
        v-model="form.phone"
        type="number"
        name="手机号"
        label="手机号"
        @input="inputPhone"
        :error-message="errMsg.phone"
        placeholder="请输入手机号"
      />
      <div class="grade_picker">
        <van-field
          readonly
          clickable
          label="年级"
          placeholder="请选择就读的年级"
          :value="form.grade_name"
          :error-message="errMsg.grade"
          @click="showGradePicker = true"
        />
        <div class="left_icon"></div>
      </div>
      <div style="margin: 16px;">
        <van-button
          round
          block
          native-type="submit"
          :class="['submit-btn', canSubmit ? 'submit-btn-active' : 'submit-btn-unActive']"
          :disabled="!canSubmit"
          >提交</van-button
        >
      </div>
    </van-form>
    <div v-if="confirmSubmit"></div>
    <van-popup v-model="showGradePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="gradeList"
        @confirm="onConfirm"
        value-key="name"
        @cancel="showGradePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
// import gradeList from '../config/gradeList.js'
export default {
  name: 'Apply',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        grade_id: '',
        grade_name: ''
      },
      showGradePicker: false,
      confirmSubmit: {},
      errMsg: {
        name: '', // 姓名
        phone: '', // 身份证
        grade: ''
      },
      canSubmit: false,
      gradeList: [],
      btnLock: false, // 按钮锁
      columns: [{ id: 1, name: '一年级' }]
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.phone && val.name && val.grade_name) {
          console.log('isMobilePhone true', this.$validator.isMobilePhone(val.phone))
          this.canSubmit = true
        } else {
          this.canSubmit = false
        }
      },
      deep: true
    }
  },
  created() {
    this.getGradeList()
    // this.gradeList = gradeList
  },
  beforeRouteLeave(to, from, next) {
    // 返回首页时，关闭弹窗
    this.$xesAlert.close()
    next()
  },
  methods: {
    inputName(val) {
      if (!this.$validator.isLength(val, { min: 0, max: 5 })) {
        this.form.name = this.form.name.substr(0, 5)
      }
    },
    inputPhone(val) {
      if (!this.$validator.isLength(val, { min: 0, max: 11 })) {
        this.form.phone = this.form.phone.substr(0, 11)
      }
    },
    // 确认选择一个年级
    onConfirm(val) {
      console.log('确认选择一个年级', val)
      this.form.grade_name = val.name
      this.form.grade_id = val.id + ''
      this.errMsg.grade = ''
      this.showGradePicker = false
    },
    onSubmit(val) {
      if (!/^[\u4e00-\u9fa5a-zA-Z]+$/.test(this.form.name)) {
        this.$toast('请输入正确的姓名')
        return
      }
      if (!this.$validator.isMobilePhone(this.form.phone, ['zh-CN'])) {
        this.$toast('请输入正确的手机号')
        return
      }
      console.log('onsubmit', val, this.form)
      this.$xesAlert({
        type: 'confirm',
        // title: 'aa',
        // message: '提交信息后不可修改\n' + '确认填写信息无误',
        message: '<div>提交信息后不可修改</div><div>确认填写信息无误</div>',
        sureText: '确认',
        cancelText: '取消',
        onSure: () => {
          // 确认无误，确认提交
          this.apply()
        },
        onCancel: () => {
          this.btnLock = false
          // 检查输入
          console.log('检查输入')
        }
      })
    },
    async apply() {
      if (this.btnLock) {
        return
      }
      this.btnLock = true
      const res = await this.$api.apply({ ...this.form, grade_id: this.form.grade_id.toString() })
      this.btnLock = false
      if (res.code === 0) {
        this.$xesLogger.clickMsg({
          params: { clickid: '50.0.0', elemname: '报名成功' }
        })
        this.$router.go(-1)
      } else {
        this.$xesLogger.clickMsg({
          params: { clickid: '50.1.0', elemname: '报名失败', message: res.message }
        })
        this.$toast(res.msg || '活动报名失败')
      }
    },
    async getGradeList() {
      const res = await this.$api.getGradeList()
      if (res.code === 0) {
        this.gradeList = res.data.list
      } else {
        this.$toast(res.msg || '获取年级列表失败')
      }
    }
  }
}
</script>
<style lang="less">
.apply {
  position: relative;
  min-height: 100vh;
  padding-top: 100px;
  padding-bottom: 25px;
  background-image: url('../assets/apply/bg.png'), linear-gradient(230deg, #fffaee, #fff0da);
  background-size: contain;
  background-repeat: no-repeat;

  .header {
    position: absolute;
    top: 90px;
    left: 50%;
    z-index: 2;
    width: 232px;
    height: 37px;
    background-image: url('../assets/apply/header_img.png');
    background-size: cover;
    background-repeat: no-repeat;
    transform: translateX(-50%);
  }

  .apply-content {
    position: relative;
    width: 351px;
    min-height: 525px;
    margin: auto;
    overflow: hidden;
    font-family: PingFangSC-Medium, PingFang SC;
    background: white;
    border-radius: 8px;

    .title {
      padding: 49px 24px 20px;
      text-align: center;

      .main-title {
        font-size: 17px;
        font-weight: 500;
        color: #333;

        .line {
          color: rgba(19, 20, 20, 0.2);
        }
      }

      .sub-title {
        margin: 6px 0;
        font-size: 11px;
        font-weight: 400;
        color: #999;
      }
    }

    .grade_picker {
      position: relative;

      .left_icon {
        position: absolute;
        top: 23px;
        //right: 40px;
        left: 290px;
        width: 12px;
        height: 12px;
        background-image: url('../assets/images/apply/left_icon.png');
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .submit-btn {
      position: absolute;
      bottom: 28px;
      left: 50%;
      width: 232px;
      height: 40px;
      font-size: 15px;
      font-weight: 500;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      transform: translateX(-50%);
    }

    .submit-btn-active {
      color: #fff;
      background: #e02627;
    }

    .submit-btn-unActive {
      color: #999;
      background: rgba(153, 153, 153, 0.1);
    }
  }
}
</style>
<style lang="less">
.apply {
  .xes-alert-message {
    color: #333;
  }

  .van-cell {
    padding: 10px 16px 10px 20px;
    font-size: 14px;
  }

  .van-field__label,
  .van-field__body {
    width: 50px;
    height: 40px;
  }

  .van-field__label {
    line-height: 40px;
  }

  .van-field__body {
    width: 245px;
    padding: 10px 16px;
    background: #f5f5f6;
    border-radius: 20px;
  }

  .van-cell::after {
    border-bottom: none;
  }
}
</style>
